import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import styled from 'styled-components';
import { useState } from 'react';
import { history } from '../../helpers/history';
import React from 'react';
import { useTranslation } from '../../commons/useTranslasion';

const BuscaContatos: React.FC = () => {
  const { translate } = useTranslation();
  const [textoBusca, setTextoBusca] = useState<string>('');

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    history.push(`/assessorados?busca=${textoBusca}`);
  }

  return (
    <PaperBusca as="form" sx={{ p: '2px 4px' }} onSubmit={submitSearch}>
      <InputBase
        sx={{ ml: 1, flex: 1 }}
        placeholder={translate('pesquisarContatos')}
        inputProps={{ 'aria-label': 'pesquisar contatos' }}
        onChange={(e) => setTextoBusca(e.target.value)}
      />
      <IconButton type="button" sx={{ p: '10px' }} aria-label="search" onClick={submitSearch}>
        <SearchIcon />
      </IconButton>
    </PaperBusca>
  );
}

const PaperBusca = styled(Paper)`
  display: flex;
  align-items: center;
  width: 360px;
  border-radius: 17px !important;

  @media (max-width: 600px) {
    display: none;
  }
`;

export default BuscaContatos;
